import React, {useState, useEffect, lazy, Suspense, useMemo} from "react";
import {useLocation, useHistory} from "react-router-dom";
import "react-datetime/css/react-datetime.css";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import PlacesAutocomplete, {
    geocodeByAddress,
} from "react-places-autocomplete";
import TextField from "../../../components/TextField/TextField";
import {  useRef } from "react";
import styled from "styled-components";
import {
  Modal,
  Form,
  Table,
  Row,
  Col,
  Button,
  Pagination,
  Spinner,
  InputGroup,
  Toast
} from "react-bootstrap";
import {
  LocalGroceryStore,
  UnfoldMore,
  Edit,
  AccountBalanceWallet,
  Block,
  SettingsBackupRestore,
  History,
} from "@material-ui/icons";
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import API from "../../../network/dashboardAPI";

import {browSer} from "../../../helper/constant";
import { Tooltip, Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText, Paper, TableContainer, Table as MTable, TableHead, TableBody, TableRow, TableCell, Slide, Typography, Divider, Input, Radio, FormControlLabel, CircularProgress, Box} from "@material-ui/core";
import Axios from "axios";
import download from "js-file-download";
import { baseUrl } from "../../../constants/Constant";
import Can from "../../../components/Allow/Can";
import EditCustomerAddress from "../../../components/EditCustomerAddress/EditCustomerAddress";
import { useWallet } from '../../../services/useWallet';
import WalletTransactionDialog from "../../../components/WalletManagement/WalletTransactionDialog";
import AddWalletTransactionDialog from "../../../components/WalletManagement/AddWalletTransactionDialog";
import UpdateWalletTransactionDialog from "../../../components/WalletManagement/UpdateWalletTransactionDialog";
import UpdateCustomerDialog from "./components/UpdateCustomerDialog";

//styles
import {TableBodyWidth, HelpPageWrapper, MuiTableStyle, labelStyle} from './styles';
import ListCouponOwnerDialog from "../../../components/CouponComponent/ListCouponOwnerDialog";
import GenerateCouponDialog from "../../../components/CouponComponent/GenerateCouponDialog";
import useAlert from "../../../services/useAlert";

const GoogleMaps = lazy(() => import("../../../components/GoogleMaps"));

// Initialize geocoder lazily when Google Maps is available
let geocoder = null;
const getGeocoder = () => {
  if (!geocoder && window.google && window.google.maps) {
    geocoder = new window.google.maps.Geocoder();
  }
  return geocoder;
};

let getLat;
let getLng;

//use wallet contexts

const Customer = (props) => {
  let admin = localStorage.getItem("admin");
  let mql = window.matchMedia("all and (min-width: 769px)");
	const location = useLocation();
	const history = useHistory();
	const params = new URLSearchParams(location.search);
	const searchTerm = params.get("search");
	const alert = useAlert();
	const {
      // state
      isWalletRequesting,
      isRequestingUpsert,
      walletTransactions,
      walletInfo,
      nextOffset,
      isShowWalletTransactionModal,
      isShowAddWalletTranModal,
		isShowUpdateWalletTranModal,
      customerToViewWallet,
		editCustomer,
		selectedTransaction,
      walletFormError,
		reason, amount, comment, transactionType, orderNumber,

      // setters
      setReason, setAmount, setComment, setTransactionType, setOrderNumber,

      // handlers
      handleViewWalletTransaction,
      handleCloseWalletTransactionModal,
      handleLoadMoreTransactions,
      handleOpenAddWalletTransactionModal,
      handleCloseAddWalletTransactionModal,
      handleSubmitAddWalletTransaction,
		handleOpenUpdateWalletTransactionModal,
		handleCloseUpdateWalletTransactionModal,
		handleSubmitUpdateWalletTransaction,
      setIsShowAddWalletTranModal,
  } = useWallet();

  if (!admin) window.location.href = "/";

  const [customers, setCustomers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [recentOrderLoading, setRecentOrderLoading] = useState(false);
  const [customerTotal, setCustomersTotal] = useState([]);
  const [perPage, setPerPage] = useState(20);
  const [customerOffset, setCustomerOffset] = useState(0);
  const [currentNumberCustomerDisplay, setCurrentNumberCustomerDisplay] =
    useState(20);
  const [recentOrders, setRecentOrders] = useState([]);
  const [sortBy, setSortBy] = useState("DESC");
  const [dialogOrder, setDialogOrder] = useState(false);
  const [recentOrderTitle, setRecentOrderTitle] = useState("Recent orders");
  const [isOpenUpdateModal, setIsOpenUpdateModal] = useState(false);
  const [editCustom, setEditCustomer] = useState({});
  const [isRequesting, setIsRequesting] = useState(false);

  // Form update customer props
  const [username, setUsername] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
	const [phone, setPhone] = useState("");
	const [countryCode, setCountryCode] = useState("");
  const [enableExpress, setEnableExpress] = useState(false);
  const [validated, setValidated] = useState(false);
  const [address, setAddress] = useState([]);
  const [disableLog, setDisableLog] = useState([]);
  const [area, setArea] = useState("");
  const [indexCustomer, setIndexCustomer] = useState("");
  // Map
  const [isShowMapModal, setIsShowMapModal] = useState(false);
  const [logDialogOpen, setLogDialogOpen] = useState(false);
  const [coordinate, setCoordinate] = useState({
    latitude: "",
    longitude: ""
  })
  //primary addr state
  const [itemListDeliveryAddr, setItemListDeliveryAddr] = useState([]);
  const [cusIdPrimaryAddr, setCusIdPrimaryAddr] = useState(null);
  const [isUpdatePrimaryAddressReqeust, setIsUpdatePrimaryAddressReqeust] = useState(false);
  const [indexPrimaryAddr, setIindexPrimaryAddr] = useState(null);

  const [marker, setMarker] = useState(false);
  const [addressToUpdate, setAddressToUpdate] = useState("");
  const [indexAddress, setIndexAddress] = useState(null);
  const [modalshow, setModalShow] = useState(false);
  const [dialogShow, setDialogShow] = useState(false);
  const initialError={
        first_name:"",
        last_name:'',
        country_code:'',
        mobile_number:'',
        street_details:'',
        area_details:'',
        city:'',
        saveAs:'',
        house_number:'',
        search_pin:''
    }
  const [error,setError]=useState(initialError);
  const [city, setCity] = useState("");
  const [isUpdateAddressReqeust, setIsUpdateAddressRequest] = useState(false);

  // toast states
  const [toastBgColor, setToastBgColor] = useState('bg-success');
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("Delete successful");

  // Filter states
  const [selectedStatus, setSelectedStatus] = useState("all");

  // Use ref
  const _textSearch = React.useRef("");

  // form error
    const [formError, setFormError] = useState({
        username: false,
        firstName: false,
        lastName: false,
        email: false,
        phone: false
    })

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [isShowConfirmModalCustomer, setIsShowConfirmModalCustomer] = useState(false);
  const [custIdAccount, setCustIdAccount] = useState(0);
    
  const isErrorDate = useMemo(() => {
		return moment(startDate).isAfter(moment(endDate));
	}, [startDate, endDate]);

  const getCustomerBy = async (
    search = "",
    fieldName = selectedStatus === "deleted" ? "updatedAt" : "createdAt",
    orderBy = "DESC",
    limit = perPage,
    offset = 0
  ) => {
    try {
      setIsLoading(true);
      const query = selectedStatus;
      API.getCustomers(query, { search, fieldName, orderBy, limit, offset })
        .then((res) => res.json())
        .then((res) => {
          if (res.success) {
            setCustomersTotal(res.total);
            setCustomers(res.result);
          } else {
            alert("Sort not found");
          }
          setIsLoading(false);
        });
    } catch (e) {
      console.log("Error, can not find customer", e);
      setCustomers([]);
      setIsLoading(false);
    }
  };

  const getRecentOrdersByCustomer = async (cust_id) => {
    try {
      setRecentOrderLoading(true);
      API.getRecentOrdersByCustomer({ cust_id })
        .then((res) => res.json())
        .then((res) => {
          if (res.success) {
            setRecentOrders(res.result);
          }

          setRecentOrderLoading(false);
        });
    } catch (e) {
      console.log("Error, can not find customer", e);
      setRecentOrders([]);
      setRecentOrderLoading(false);
    }
  };

  // Map function
  const onMarkerDragEnd = async (t, map, coord) => {
    setMarker(true);
    const { latLng } = coord;
    setCoordinate({
      latitude: latLng.lat(),
      longitude: latLng.lng(),
    })
  };

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        // Success function
        showPosition,
        // Error function
        defaultPosition,
        // Options. See MDN for details.
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  const showPosition = (position) => {
    setMarker(true);
    getLat = position.coords.latitude;
    getLng = position.coords.longitude;
    setCoordinate({
      latitude: getLat,
      longitude: getLng
    })
  };

  const defaultPosition = () => {
    setCoordinate({latitude: props.item.latitude ? props.item.latitude : 11.5564, longitude: props.item.long ? props.item.long : 104.9282})
    if (browSer() === "Chrome"){
      if(window.location.hostname === "dev.delishop.asia"){
        alert("Location permissions not allowed for Google Chrome , allow your location by following this link in another tab chrome://settings/content/siteDetails?site=https://dev.delishop.asia/");
      }
      else{
        alert("Location permissions not allowed for Google Chrome , allow your location by following this link in another tab chrome://settings/content/siteDetails?site=https://delishop.asia/");
      }
    }
    else if(browSer() === "Safari"){
      if(window.location.hostname === "dev.delishop.asia"){
        alert("Location permissions not allowed for Safari , allow your location by following these steps : \nSafari -> Preferences -> Websites tab -> Location -> dev.delishop.asia -> allow");
      }
      else{
        alert("Location permissions not allowed for Safari , allow your location by following these steps : \nSafari -> Preferences -> Websites tab -> Location -> delishop.asia -> allow");
      }
    }
  };

  //setup before functions
  let typingTimer; //timer identifier
  let doneTypingInterval = 750; //time in ms (7.5 seconds)
  const doSearch = (value) => {
    clearTimeout(typingTimer);
	  if (searchTerm) {
		  params.delete("search");

		  history.replace({
			  pathname: location.pathname,
			  search: params.toString(),
		  });
	  }
    typingTimer = setTimeout(function () {
      getCustomerBy(value);
    }, doneTypingInterval);
  };

  const dialogOrderShow = async (cust_id, name) => {
    await getRecentOrdersByCustomer(cust_id);

    setRecentOrderTitle(`Recent order (${name})`);
    setDialogOrder(true);
  };
  const dialogOrderClose = () => {
    setDialogOrder(false);
  };

  const sortToggle = (item) => {
    if (sortBy === "DESC") setSortBy("ASC");
    else setSortBy("DESC");

    getCustomerBy("", item, sortBy);
  };

  const setFormData = (customer) => {
    setUsername(customer.name);
    setFirstName(customer.first_name);
    setLastName(customer.last_name);
    setEmail(customer.email);
	  setPhone(customer.phone);
	  setCountryCode(customer.country_code);
    if (customer && customer.enable_express) {
      setEnableExpress(customer.enable_express);
    }

    if(customer && customer.list_customer_addresses){
      setAddress(customer.list_customer_addresses);
      setItemListDeliveryAddr(customer.list_customer_addresses);
    }
  };

  const resetFormData = () => {
    setUsername("");
    setFirstName("");
    setLastName("");
    setEmail("");
	  setPhone("");
	  setCountryCode("");
    setAddress([]);
    setEnableExpress(false);
    setEditCustomer({});
    setIndexCustomer("");
  };

  const checkFormValidate = () => {
        let error = {};
        if (!username) {
            error.username = true;
        }else{
            error.username = false;
        }

        if (!firstName) {
            error.firstName = true;
        }else{
            error.firstName = false;
        }

        if (!lastName) {
            error.lastName = true;
        }else{
            error.lastName = false;
        }

	  // if (!email) {
	  //     error.email = true;
	  // }else{
	  //     error.email = false;
	  // }
	  //
        if (!phone) {
            error.phone = true;
        }else{
            error.phone = false
        }

        setFormError(error);

        return Object.values(error).every(el => el === false);
    };

  const resetPagination = () => {
    setCustomerOffset(0)
  }

  const handleEditCustomer = async (customer, index) => {
    const cloneCustomer = Object.assign({}, customer);
    setEditCustomer(cloneCustomer);
    setFormData(cloneCustomer);
    setIndexCustomer(index);
    setIsOpenUpdateModal(true);
    setCustomerMail(customer.email);
    setDpBalance(customer.dp_balance ?? 0);
    setDpTierId(customer.dp_tier_id ?? null);
    // Pre-fill selected tier from the customer's delipoints_tier object
    if (customer.delipoints_tier) {
      const t = customer.delipoints_tier;
      setDpSelectedTier({
        label: t.name,
        value: t.name,
        id: t.dp_tier_id ?? t._id ?? t.id,
        imageUrl: t.image,
      });
    } else {
      setDpSelectedTier(null);
    }
    // Pre-fill grace tier from the customer's grace_delipoints_tier object
    if (customer.grace_delipoints_tier) {
      const g = customer.grace_delipoints_tier;
      setDpGraceTierId(customer.dp_tier_grace_period_id ?? g.dp_tier_id ?? null);
      setDpGraceSelectedTier({
        label: g.name,
        value: g.name,
        id: g.dp_tier_id ?? g._id ?? g.id,
        imageUrl: g.image,
      });
    } else {
      setDpGraceTierId(null);
      setDpGraceSelectedTier(null);
    }
    await getCustomerSubscription(customer.email);
    await getCouponList(customer.cust_id);
  };

  const handleViewDisableLog = (log = []) => {
    setLogDialogOpen((prev) => !prev);
    setDisableLog(log);
  }

  const handleCloseupdateModal = () => {
      resetFormError();
    setIsOpenUpdateModal(false);
  };

  const handleStatusChange = (event) => {
    //  reset pagination
    resetPagination();

    setSelectedStatus(event.target.value);
  };

  const handleSubmit = () => {
    if(checkFormValidate()){
        // setIsRequestingUpsert(true);

        const body = {
            enable_express: enableExpress,
            cust_id: editCustom.cust_id,
            name: username,
            first_name: firstName,
		        last_name: lastName,
		        country_code: countryCode ? countryCode.value : "",
            phone: phone,
            email: email,
            dp_balance: dpBalance ?? 0,
            dp_tier_id: dpTierId ?? null,
            dp_tier_grace_period_id: dpGraceTierId ?? null,
        };
        API.updateCustomer(body)
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    resetFormData();
                    resetPagination();
                    resetSearch();
                    
                    getCustomerBy(searchTerm);
                    setIsOpenUpdateModal(false);
                    handleShowToast("SUCCESS");
                }else{
                    handleShowToast("ERROR");
                }
            });
    }
  };

  const handleEnableDisableUser = (custId, status) => {
    if (
      !window.confirm(
        status === 0
          ? "Are you sure to disable this user?"
          : "Are you sure to enable this user?"
      )
    )
      return;

    const body = {
      cust_id: custId,
      is_authorised: status,
    };

    API.updateCustomer(body)
    .then((response) => response.json())
    .then((response) => {
      if (response.success) {
        getCustomerBy(_textSearch && _textSearch.current && _textSearch.current.value);
        handleShowToast("SUCCESS");
      } else{
        handleShowToast("ERROR");
      }
    });
  }

  const resetFormError = () => {
      setFormError({
          username: false,
          lastName: false,
          firstName: false,
          email: false,
          phone: false
      })
  }

  const resetSearch = () => {
      if(_textSearch && _textSearch.current && _textSearch.current.value){
          _textSearch.current.value = ""
      }
  }

  const resetWalletFormData = () => {
    setAmount(0);
    setReason("refund");
    setComment("");
    setTransactionType("credit");
  };

    // toast event
    const handleShowToast = (type) => {
        setShowToast(true);

        if(type === "SUCCESS"){
            setToastBgColor("bg-success");
            setToastMessage("Operation successful.");
        }else if(type === "ERROR"){
            setToastBgColor("bg-danger");
            setToastMessage("Operation error.");
        }
    }

  const initialUpdatePrimaryAddress = (data) => {
    const cusIndex = customers.findIndex((item) => item.cust_id === cusIdPrimaryAddr);
    if(cusIndex > -1){
      customers[cusIndex]["list_customer_addresses"] = data;
    }
}

  const handleCloseMap = () => {
        setAddressToUpdate({});
        setArea("")
        setIndexAddress("");
        setIsShowMapModal(false);
        setCity("")
        setModalShow(false);
        setCoordinate({latitude: "", longitude: ""})
    }

    const handleViewMap = (address, index) => {
        setAddressToUpdate(address.area_details);
        setArea(address.area_details)
        setIndexAddress(index);
        setIsShowMapModal(true);
        setCity(address.city);
        setCoordinate({latitude: address.latitude, longitude: address.long})
        setTimeout(function () {
            setModalShow(true);
        }, 2500);
    }

    const changePrimaryAddress = (address_id, cust_id, index) => {
      setIindexPrimaryAddr(index);
      setIsUpdatePrimaryAddressReqeust(true);
      setCusIdPrimaryAddr(editCustom.cust_id);
      const body = {
        address_id: address_id,
        cust_id: cust_id
      };
      const query = {
        orderType: selectedStatus === "express" ? 1 : 0
      }

      API.AdminUpdatePrimaryAddress(body, query)
      .then((response) => response.json())
      .then((response)=>{
        setIsUpdatePrimaryAddressReqeust(false);
        if (response.success) {
          initialUpdatePrimaryAddress(response.data.allAddresses);
          setItemListDeliveryAddr(response.data.allAddresses);
          handleShowToast("SUCCESS");
        }else{
          handleShowToast("ERROR");
        }
      })
    }

	const setListAddress = (listAddress) => {
		initialUpdatePrimaryAddress(listAddress)
		setItemListDeliveryAddr(listAddress)
		getCustomerBy().then(r => {
		});
	}
   const handleUpdateAddress = () => {
     setIsUpdateAddressRequest(true);
     let tmpListCustomerAddress = editCustom["list_customer_addresses"][indexAddress];
      if (city == 'Phnom Penh') {
        setCity('Phnom Penh');
      } else {
        setCity("Province");
      }
     const {latitude, longitude} = coordinate;
       let body = {
           first_name: tmpListCustomerAddress.first_name,
           last_name: tmpListCustomerAddress.last_name,
           mobile_number: tmpListCustomerAddress.mobile_number,
           house_number: tmpListCustomerAddress.house_number,
           street_details: tmpListCustomerAddress.street_details,
           landmark: tmpListCustomerAddress.landmark,
           area_details: area,
           city,
           nick_name: tmpListCustomerAddress.nick_name,
           is_default: tmpListCustomerAddress.is_default,
           latitude: latitude,
           long: longitude,
           delivery_instructions: tmpListCustomerAddress.delivery_instructions,
           country_code: tmpListCustomerAddress.country_code
       };

       let addressId = tmpListCustomerAddress.address_id;

       API.UpdateAddress(addressId, body)
           .then((response) => response.json())
           .then((response) => {
               setIsUpdateAddressRequest(false);
               if (response.success) {
                   initialUpdatePrimaryAddress(response.data.allAddress)
                   setItemListDeliveryAddr(response.data.allAddress)
                   handleShowToast("SUCCESS");
               } else {
                   handleShowToast("ERROR");
               }

               handleCloseMap();
           });

       //Call api to update
     //Show toast confirm
     //
   }

    const fetchAddress = () => {
      const {latitude, longitude} = coordinate;
      const latlng = {
        lat: parseFloat(latitude),
        lng: parseFloat(longitude),
      };
      const geocoderInstance = getGeocoder();
      if (!geocoderInstance) {
        console.error('Google Maps Geocoder not available yet');
        return;
      }
      geocoderInstance.geocode({ location: latlng }, (results, status) => {
        console.log('response json', results[0]);
        const getUserLocation = results[0] && results[0].formatted_address?results[0].formatted_address: "";
        setArea(getUserLocation);
        setMarker(false);

        results[0].address_components.map(async function (
            item,
            idx
        ) {
          item.types.map(async function (item1, idx1) {
            if (item1 == "administrative_area_level_1") {
              // setCity(item.long_name)
              if (item.long_name == 'Phnom Penh') {
                setCity('Phnom Penh');
              } else {
                setCity("Province");
              }
            }
          });
        });
      })
    };

  useEffect(() => {
	  _textSearch.current.value = searchTerm;
    if(_textSearch && _textSearch.current && _textSearch.current.value){
        getCustomerBy(_textSearch.current.value);
    }else{
        getCustomerBy();
    }
  }, [selectedStatus]);

    useEffect(() => {
        if(marker === true){
          fetchAddress();
        }
    },[coordinate]);

  // Pagination
  let pageItems = [
    <Pagination.Item key={0}  onClick={() => paginPrev()}>
      Prev
    </Pagination.Item>,
    <Form.Group key={1} controlId="formGridPagination">
      <InputGroup>
        <InputGroup.Prepend>
          <InputGroup.Text>{`${
            currentNumberCustomerDisplay + customerOffset
          } / ${customerTotal}`}</InputGroup.Text>
        </InputGroup.Prepend>
      </InputGroup>
    </Form.Group>,
    <Pagination.Item key={2} onClick={() => paginNext()}>
      Next
    </Pagination.Item>,
  ];
  const paginationBasic = (
    <div className="d-flex justify-content-end">
      <Pagination>{pageItems}</Pagination>
    </div>
  );

  const paginNext = async () => {
    let offset = 0;

    if (customerOffset <= 0) offset = 20;
    else offset = customerOffset + perPage;

    setCustomerOffset(offset);
    getCustomerBy(null, null, null, null, offset);
  };
  const paginPrev = () => {
    let offset = 0;

    if (customerOffset <= 0) {
      setCustomerOffset(0);
    } else {
      offset = customerOffset - perPage;
      setCustomerOffset(offset);
    }

    getCustomerBy(null, null, null, null, offset);
  };

  const handleExtractWalletBalanceReport = async () => {
      try {
        setIsLoading(true);
        let baseURL = `${baseUrl}v1/admin/wallet/transaction/extract`;
        if (startDate && endDate && !isErrorDate) {
          baseURL = `${baseUrl}v1/admin/wallet/transaction/extract?startDate=${startDate}&endDate=${endDate}`
        }
        const response = await Axios({
          method: "GET",
          url: baseURL,
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/xlsx",
          },
          responseType: "blob",
        });
        if (response.status === 200) {
          download(response.data, `WALLET_BALANCE_REPORT_${moment().format("YYYY/MM/DD")}_${moment().format("HH:mm:ss")}.xlsx`);
          setDialogShow(false)
          setIsLoading(false);
        }
      } catch (error) {
        setToastBgColor("bg-danger");
        setToastMessage("Download invoice failed!");
        setShowToast(true);
        setIsLoading(false);
        console.log("Debug error: ", error);
      }
  }
  
	const handleChangeDate = (e) => {
		let { name, value } = e.target;
		switch (name) {
			case "startDate":
				setStartDate(value);
				if (value === "" && endDate) {
					setEndDate("");
				}
				break;
			case "endDate":
				setEndDate(value);
				if (value === "" && startDate) {
					setStartDate("");
				}
				break;
			default:
				break;
		}
	};

  const DeletedAccount = ({label}) => {
    return (
      <span className="text-muted font-italic">
        {label ? label : "Deleted account"}
      </span>
    )
  }

  const handleOpenConfirmModalCustomerSelect = (cust_id) => {
    setCustIdAccount(cust_id);
    setIsShowConfirmModalCustomer(true);
  };

  const handleCloseConfirmModalCustomerSelect = () => {
    setCustIdAccount(0);
    setIsShowConfirmModalCustomer(false);
  };

  const handleDeleteAccount = (body) => {

    API.deleteCustomer(body)
      .then((response) => response.json())
      .then((response)=>{
        if (response.success) {
          setCustIdAccount(0);
          handleShowToast("SUCCESS");
          getCustomerBy();
        }else{
          handleShowToast("ERROR");
        }
        handleCloseConfirmModalCustomerSelect();
      })
  }

  const [modal,setModal] = useState(false);
	const [addressData, setAddressData] = useState(null);
	const [addressEdit, setAddressEdit] = useState(true);
	const handleToggle = (data, type = true) => {
    setModal(!modal);
    setAddressData(data)
		setAddressEdit(Boolean(type))
  };

  //****** Mail Sender API ******/
  const [subscribeStatus,setSubscribeStatus] = useState(false);
  const [customerMail,setCustomerMail] = useState(null);
  const getCustomerSubscription = async (email) => {
    await API.showSenderSubscriber(email)
    .then(res => res.json())
    .then((res) => {
      if(res.success) {
        let status = res?.data?.status;
        setSubscribeStatus(status?.email === "active" ? true : false)
      }
    });
  };
  const updateSubscriptionStatus = async () => {
    await API.AdminUpdateMailSubscribe(customerMail)
    .then(res => res.json())
    .then(async(res) => {
      if(res.success) {
        await getCustomerSubscription(customerMail)
      }else{
        alert(res.error_message)
      }
    });
  };
  //****** End of Mail Sender ******/

	//** Customer Coupon  */
	// Delipoints
	const [calculateDPTier, setCalculateDPTier] = useState(false);
	const [dpBalance, setDpBalance] = useState(0);
	const [dpTierId, setDpTierId] = useState(null);
	const [dpSelectedTier, setDpSelectedTier] = useState(null);
	const [dpGraceTierId, setDpGraceTierId] = useState(null);
	const [dpGraceSelectedTier, setDpGraceSelectedTier] = useState(null);

	// Delipoint Transactions
	const [delipointTransactions, setDelipointTransactions] = useState([]);
	const [isDelipointTransactionModalOpen, setIsDelipointTransactionModalOpen] = useState(false);
	const [isDelipointTransactionLoading, setIsDelipointTransactionLoading] = useState(false);
	const [delipointTransactionPage, setDelipointTransactionPage] = useState(0);
	const [delipointTransactionHasMore, setDelipointTransactionHasMore] = useState(true);
	const [isDelipointTransactionLoadingMore, setIsDelipointTransactionLoadingMore] = useState(false);
	const [delipointTransactionTotal, setDelipointTransactionTotal] = useState(0);

	const [couponModal, setCouponModal] = useState(false);
	const [generateCouponModal, setGenerateCouponModal] = useState(false);
	const [couponFetching, setCouponFetching] = useState(false);
	const [couponList, setCouponList] = useState([]);
	const [couponTemplateList, setCouponTemplateList] = useState([]);
	const [couponSelected, setCouponSelected] = useState(null);


	const handleGenerateCouponToCustomer = async () => {
		let body = {
			...couponSelected,
			custId: [editCustom.cust_id]
		}
		await API.createCouponToCustomerFromTemplate(body)
			.then((res) => res.json())
			.then((res) => {
				if (res.success) {
					getCouponList(editCustom.cust_id)
					setCouponModal(!couponModal)
					console.log(res)
					alert.close();
					alert.toast('Coupon Generate successfully', 'success', 1500);
					setGenerateCouponModal(false)
				} else {
					alert.close();
					alert.error('Error', res?.message);
				}
			});
	}

	const handleToggleCoupon = () => {
		setCouponModal(!couponModal)
		setGenerateCouponModal(false)
	}

	const handleToggleGenerateCoupon = async () => {
		setGenerateCouponModal(!generateCouponModal)
		setCouponModal(!couponModal)
		if (!generateCouponModal) {
			await getCouponTemplate()
		}
	}

	const getCouponTemplate = async () => {
		await API.getAllCouponTemplate()
			.then((res) => res.json())
			.then((res) => {
				if (res.success) {
					setCouponFetching(false)
					setCouponTemplateList(res.data.list)
				} else {
					setCouponFetching(false)
					setCouponTemplateList([])
				}
			});
	}

	const getCouponList = async (userId) => {
		setCouponFetching(true)
		await API.getAllCustomerPickCouponCode({
			user_id: userId
		})
			.then((res) => res.json())
			.then((res) => {
				if (res.success) {
					setCouponFetching(false)
					setCouponList(res.data)
				} else {
					setCouponFetching(false)
					setCouponList([])
				}
			});
	};

	const handleToggleModalRemoveUser = async (data = null) => {
		if (!data) return;

		const couponCode = data?.code || 'Unknown Code';
		const couponName = data?.name || 'Unnamed Coupon';
		const userName = data?.coupon_linked_customers?.[0]?.customer_detail?.name || 'Unknown User';

		const result = await alert.confirm(
			'Remove this Coupon from User?',
			`You are about to unlink "${couponName}" (${couponCode}) from user ${userName} This action cannot be undone. Are you sure?`,
			'Yes, remove',
			'Cancel'
		);

		if (result.isConfirmed) {
			const pickerData = {
				user_id: data?.coupon_linked_customers?.[0]?.user_id,
				coupon_id: data?.id,
			};

			try {
				const res = await API.RemoveCustomerPickCouponCodeByCode(pickerData);
				const json = await res.json();

				if (json.success) {
					await getCouponList(pickerData.user_id);

					alert.close();
					alert.toast('Coupon removed successfully', 'success', 2000);
				} else {
					alert.close();
					alert.error('Failed', json.message || 'Something went wrong.');
				}
			} catch (error) {
				alert.close();
				alert.error('Error', 'An unexpected error occurred.');
				console.error(error);
			}
		}
	};


	// Delipoint Transactions
	const fetchDelipointTransactions = async (cust_id, page = 0, isLoadMore = false) => {
		if (isLoadMore) {
			setIsDelipointTransactionLoadingMore(true);
		} else {
			setIsDelipointTransactionLoading(true);
		}
		try {
			const response = await Axios({
				method: 'POST',
				url: `${baseUrl}api/v1/admin/delipoints/customer/transactions`,
				headers: {
					Authorization: localStorage.getItem('token'),
				},
				data: { page, limit: 10, cust_id },
			});
			if (response.data.success) {
				const newData = response.data.data || [];
				const { total, limit } = response.data;
				
				if (isLoadMore) {
					setDelipointTransactions(prev => [...prev, ...newData]);
				} else {
					setDelipointTransactions(newData);
				}
				
				setDelipointTransactionTotal(total);
				
				// Calculate if there's more data based on total and current position
				const currentPosition = (page + 1) * limit;
				setDelipointTransactionHasMore(currentPosition < total);
			} else {
				alert('Failed to fetch transactions');
			}
		} catch (error) {
			console.error('Error fetching delipoint transactions:', error);
			alert('Error fetching transactions');
		} finally {
			if (isLoadMore) {
				setIsDelipointTransactionLoadingMore(false);
			} else {
				setIsDelipointTransactionLoading(false);
			}
		}
	};

	const handleEvaluateCustomerTier = async () => {
		setCalculateDPTier(true);
		try {
			let res = await API.evaluateCustomerTier({ cust_id: editCustom.cust_id });
			res = await res.json();
			if (res.success) {
				const fieldName = selectedStatus === "deleted" ? "updatedAt" : "createdAt";
				let listRes = await API.getCustomers(selectedStatus, { search: searchTerm ?? "", fieldName, orderBy: "DESC", limit: perPage, offset: 0 });
				listRes = await listRes.json();
				if (listRes.success) {
					setCustomers(listRes.result);
					setCustomersTotal(listRes.total);
					const updated = listRes.result.find(c => c.cust_id === editCustom.cust_id);
					if (updated) {
						setEditCustomer(prev => ({ ...prev, ...updated }));
					}
				}
			}
		} catch (e) {
			console.error(e);
		} finally {
			setCalculateDPTier(false);
		}
	};

	const handleViewDelipointTransactions = () => {
		setDelipointTransactionPage(0);
		setDelipointTransactionHasMore(true);
		setDelipointTransactions([]);
		fetchDelipointTransactions(editCustom.cust_id, 0, false);
		setIsDelipointTransactionModalOpen(true);
	};

	const handleLoadMoreDelipointTransactions = () => {
		if (!isDelipointTransactionLoadingMore && delipointTransactionHasMore) {
			const nextPage = delipointTransactionPage + 1;
			setDelipointTransactionPage(nextPage);
			fetchDelipointTransactions(editCustom.cust_id, nextPage, true);
		}
	};

	const handleCloseDelipointTransactionModal = () => {
		setIsDelipointTransactionModalOpen(false);
		setDelipointTransactions([]);
		setDelipointTransactionPage(0);
		setDelipointTransactionHasMore(true);
		setDelipointTransactionTotal(0);
	};


	useEffect(() => {
		if (isShowAddWalletTranModal) {
			resetWalletFormData();
            if(editCustomer && editCustomer.cust_id){
                getRecentOrdersByCustomer(editCustomer.cust_id)
            }
		}
	}, [isShowAddWalletTranModal]);

	useEffect(() => {
		if (isShowUpdateWalletTranModal) {
			if (selectedTransaction && selectedTransaction.wallet_owner_id) {
				getRecentOrdersByCustomer(selectedTransaction.wallet_owner_id)
			}
		}
	}, [isShowUpdateWalletTranModal]);

    const orderOptions = useMemo(() => {
        if (!recentOrders || !recentOrders.length) return [];
        let options = [];
        recentOrders.forEach(order => {
            if (order.order_payment_details && order.order_payment_details.length) {
                order.order_payment_details.forEach(detail => {
                    options.push({
                        value: detail.order_id,
                        label: `${detail.order_id}`
                    })
                })
            }
        });
        return options;
    }, [recentOrders]);
	//** End Customer Coupon */

	return (
    <HelpPageWrapper>
      <Row>
        <Col sm={12}>
          <Row className="mb-3">
            <Col sm={8}>
              <Form.Control
                style={{ width: "25rem" }}
                size="md"
                type="text"
                ref={_textSearch}
                placeholder="Search customers"
                onChange={(e) => doSearch(e.target.value)}
              />
            </Col>

            <Col sm={3} md={3} className="d-flex justify-content-end">
              <Form.Label style={labelStyle}>Filter: </Form.Label>&nbsp;&nbsp;
              <Form.Control
                as="select"
                onChange={handleStatusChange}
                value={selectedStatus}
              >
                <option value={"all"}>All customer</option>
                <option value={"noExpress"}>Normal customer</option>
                <option value={"express"}>Express customer</option>
                <option value={"disabled"}>Disabled customer</option>
                <option value={"deleted"}>Deleted customer</option>
              </Form.Control>
            </Col>
            <Col sm={3} md={1}>
              <Tooltip title="Extract customers' wallet balance report" arrow>
                <Button variant="outline-success" onClick={() => setDialogShow(true)}>
                  <AccountBalanceWallet />
                </Button>
              </Tooltip>
            </Col>
          </Row>

          <TableBodyWidth
            className="table-responsive"
            style={{ overflowY: "hidden" }}
          >
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th className="sortable" onClick={() => sortToggle("name")}>
                    Username <UnfoldMore />
                  </th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Address</th>
                  <th
                    className="sortable"
                    onClick={() => sortToggle("createdAt")}
                  >
                    Created date <UnfoldMore />
                  </th>
                  <th className="text-center">Delipoints</th>
                  <th style={{ minWidth: "20vh" }} className="text-center">
                    Wallet
                  </th>
                  <th style={{ minWidth: "15vh" }} className="text-center">
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody>
                {!isLoading ? (
                  customers.map((item, index) => (
                    <tr key={index}>
                      <td>
                        {item.is_deleted ? <DeletedAccount /> : (item.name && item.name !== " ") ? item.name : "N/A"}
                      </td>
                      <td>{item.is_deleted ? <DeletedAccount /> : item.first_name || "N/A"}</td>
                      <td>{item.is_deleted ? <DeletedAccount /> : item.last_name || "N/A"}</td>
                      <td>{item.is_deleted ? <DeletedAccount /> : item.email || "N/A"}</td>
                        <td>{item.is_deleted ? <DeletedAccount /> : (item.country_code && item.phone && ("+"+ item.country_code + " ")) + item.phone || "N/A"}</td>
                      <td>
                        {item.is_deleted ? 
                          <DeletedAccount label={item.list_customer_addresses} />
                        : 
                          item.list_customer_addresses?.length
                          ? item.list_customer_addresses.map(
                              (row, subIndex) => (
                                <p key={subIndex}>
                                  &bull;&nbsp;{row.area_details}
                                </p>
                              )
                            )
                          : "No data"}
                      </td>
                      <td>{item.is_deleted ? <DeletedAccount /> : moment(item.createdAt).format("Do MMMM YYYY")}</td>
                      <td className="text-center">
                        {item.is_deleted ? <DeletedAccount /> : (
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
                            {item.delipoints_tier && (
                              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                {item.delipoints_tier.image && (
                                  <img
                                    src={item.delipoints_tier.image}
                                    alt={item.delipoints_tier.name}
                                    style={{ width: 20, height: 20, objectFit: "contain" }}
                                  />
                                )}
                                <span style={{ fontSize: 12, fontWeight: 600 }}>{item.delipoints_tier.name || "N/A"}</span>
                              </div>
                            )}
                            <span style={{ fontSize: 12, color: "#555" }}>
                              {item.dp_balance != null ? `${item.dp_balance} pts` : "N/A"}
                            </span>
                          </div>
                        )}
                      </td>
                      <td className="d-flex justify-content-center">
                        <>
                          <Button
                            variant="info"
                            onClick={() => handleViewWalletTransaction(item)}
                          >
                            View
                          </Button>
                          <Can
                            headPermit="Customers" 
                            keyPermit="customers_update_wallet"
                          >
                            &nbsp;&nbsp;
                              <Button
                                variant="info"
                                onClick={() =>
                                  handleOpenAddWalletTransactionModal(item)
                                }
                              >
                                Update
                              </Button>
                          </Can>
                        </>
                      </td>
                      <td>
                        {item.is_deleted ? 
                          <DeletedAccount /> 
                        : 
                          <div style={{ height: "100%", display: "flex", gap: 8}}>
                            <Button
                              variant="info"
                              onClick={() =>
                                dialogOrderShow(item.cust_id, item.name)
                              }
                            >
                              <LocalGroceryStore></LocalGroceryStore>
                            </Button>
                            &nbsp;&nbsp;
                            <Button
                              variant="info"
                              onClick={() => handleEditCustomer(item, index)}
                            >
                              <Edit></Edit>
                            </Button>
                            <Tooltip
                              arrow
                              title={
                                parseInt(item.is_authorised) === 1
                                  ? "Disable User"
                                  : "Enable User"
                              }
                            >
                              <Button
                                variant={
                                  parseInt(item.is_authorised) === 1 ? "danger" : "primary"
                                }
                                onClick={() =>
                                  handleEnableDisableUser(
                                    item.cust_id,
                                    parseInt(item.is_authorised) === 1 ? 0 : 1
                                  )
                                }
                              >
                                {parseInt(item.is_authorised) === 1 ? (
                                  <Block />
                                ) : (
                                  <SettingsBackupRestore />
                                )}
                              </Button>
                            </Tooltip>
                            <Tooltip arrow title="Logs">
                              <Button variant="secondary" onClick={() => handleViewDisableLog(item.disable_log)}>
                                <History />
                              </Button>
                            </Tooltip>
                            <Tooltip arrow title="Delete account">
                              <Button variant="danger" onClick={() => handleOpenConfirmModalCustomerSelect(item.cust_id)}>
                                <HighlightOffIcon />
                              </Button>
                            </Tooltip>
                          </div>
                        }
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={12} className="text-center">
                      <Spinner animation="grow" />
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </TableBodyWidth>

          {/* Modal confirm cancel all orders seleted*/}
          <Modal
              show={isShowConfirmModalCustomer}
              animation={false}
              onHide={handleCloseConfirmModalCustomerSelect}
              aria-labelledby="contained-modal-title-vcenter"
              size="xs"
              centered
          >
            <Modal.Header closeButton className="bg-danger">
              <Modal.Title className="text-white">Warning</Modal.Title>
            </Modal.Header>
            <Modal.Body key="modalBody" className="text-center">
              <Form.Label>Are you sure you want to delete this customer?</Form.Label>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-center">
              <Button
                  variant="danger"
                  onClick={(e) => handleDeleteAccount({cust_id: custIdAccount})}
              >
                OK
              </Button>
              <Button variant="secondary" onClick={handleCloseConfirmModalCustomerSelect}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

					<Dialog
						fullWidth
						maxWidth="sm"
						scroll="body"
						open={logDialogOpen}
						onClose={() => setLogDialogOpen(false)}
					>
						<DialogTitle>Disabled Customer Logs</DialogTitle>
						<DialogContent dividers>
							<MuiTableStyle>
								<Paper>
									<TableContainer style={{ maxHeight: window.innerHeight - 200 }}>
										<MTable>
											<TableHead>
												<TableRow>
													<TableCell component="th">Action</TableCell>
													<TableCell component="th">Modifier</TableCell>
													<TableCell component="th">Modified Date</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												{disableLog && disableLog?.length ? (
													disableLog?.map((log, index) => {
														return (
															<TableRow key={index} hover>
																<TableCell
																	className={
																		log?.action === "Disable" ? "text-danger" : "text-primary"
																	}
																>
																	{log?.action}
																</TableCell>
																<TableCell>{log?.modifier}</TableCell>
																<TableCell>
																	{moment(log?.modified_date).format("DD/MMM/YYYY HH:mm:ss")}
																</TableCell>
															</TableRow>
														);
													})
												) : (
													<TableRow>
														<TableCell align="center" colSpan={3}>
															No Data
														</TableCell>
													</TableRow>
												)}
											</TableBody>
										</MTable>
									</TableContainer>
								</Paper>
							</MuiTableStyle>
						</DialogContent>
						<DialogActions>
							<Button
								variant="light"
								size="sm"
								onClick={() => setLogDialogOpen(false)}
							>
								Close
							</Button>
						</DialogActions>
					</Dialog>

          <Dialog open={dialogShow} onClose={() => setDialogShow(false)}>
            <DialogTitle className="text-success text-center">
              <AccountBalanceWallet fontSize="large"/>
            </DialogTitle>
            <DialogContent>
					    <DialogContentText color="textPrimary">
						    Extract customers' wallet balance report
					    </DialogContentText>
					    <DialogContentText color="textPrimary">
                From:
                <TextField
                  type="date"
                  variant="outlined"
                  size="small"
                  name="startDate"
                  value={startDate}
                  error={isErrorDate}
                  helperText={
                    isErrorDate && (
                      <span className="text-danger">
                        Start date must be after end date
                      </span>
                    )
                  }
                  onChange={handleChangeDate}
                />
              </DialogContentText>
					    <DialogContentText color="textPrimary">
                To:
                <TextField
                  type="date"
                  variant="outlined"
                  size="small"
                  name="endDate"
                  value={endDate}
                  disabled={!startDate}
                  onChange={handleChangeDate}
                />
              </DialogContentText>
				    </DialogContent>
            <DialogActions>
              <Button
                variant="light" 
                size="sm"
                disabled={isLoading}
                onClick={() => setDialogShow(false)}
              >
                Close
              </Button>
              <Button 
                variant="outline-success" 
                size="sm"
                disabled={isLoading}
                onClick={handleExtractWalletBalanceReport}
              >
                {isLoading ? "Loading..." : "Extract"}
              </Button>
            </DialogActions>
          </Dialog>

          <Modal
            show={dialogOrder}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            size="lg"
            onHide={dialogOrderClose}
          >
            <Modal.Header closeButton>
              <Modal.Title>{recentOrderTitle}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Order ID</th>
	                  <th></th>
	                  <th>Order Date</th>
                    <th>Payment Type</th>
                    <th>Amount</th>
                    <th>Delivery Date/Time</th>
                  </tr>
                </thead>

                <tbody>
                  {recentOrders.length ? (
                    recentOrders.map((value) => {
                      return value.order_payment_details.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <Link
                              target="_blank"
                              to={{
                                pathname:
                                  "/admin/order/details/" + item.order_id,
                              }}
                            >
                              {item.order_id}
                            </Link>
                          </td>
	                        <td>
		                        {value.type === 1 ?
			                        <img alt={"express"} src={require("../../../assets/delixpress_round_logo.png")} width="32" height="32"/> :
			                        <img alt="normal" src={require("../../../assets/delishop_round_logo.png")} width="32" height="32"/>
		                        }
	                        </td>
                          <td>
                            {moment(value.placedAt).format("ll hh:mm:ss") ||
                              "N/A"}
                          </td>
                          <td>{value.payment_method_name || "N/A"}</td>
                          <td>
                            {item.amount
                              ? "$" + parseFloat(item.amount).toFixed(2)
                              : "N/A"}
                          </td>
                          <td>
	                          {value.start_time && value.end_time ? moment(value.start_time).format("ll hh:mm A") +
                              " to " +
	                          moment(value.end_time).format("hh:mm A") || "N/A" : moment(value.placedAt).format("ll hh:mm A")}
                          </td>
                        </tr>
                      ));
                    })
                  ) : recentOrderLoading ? (
                    <tr>
                      <td colSpan={12} className="text-center">
                        <Spinner animation="grow" />
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td colSpan={12} className="text-center">
                        No data
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Modal.Body>

            <Modal.Footer>
              <Button variant="danger" onClick={dialogOrderClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Modal update customer */}
	        <UpdateCustomerDialog
		        isOpen={isOpenUpdateModal}
		        onClose={handleCloseupdateModal}
		        onSubmit={handleSubmit}
		        validated={validated}
		        formError={formError}
		        isSubmitting={isRequestingUpsert}
		        editCustom={editCustom}
		        username={username} setUsername={setUsername}
		        firstName={firstName} setFirstName={setFirstName}
		        lastName={lastName} setLastName={setLastName}
		        email={email} setEmail={setEmail}
		        phone={phone} setPhone={setPhone}
		        countryCode={countryCode} setCountryCode={setCountryCode}
		        enableExpress={enableExpress} setEnableExpress={setEnableExpress}
		        subscribeStatus={subscribeStatus}
		        updateSubscriptionStatus={updateSubscriptionStatus}
		        handleToggleCoupon={handleToggleCoupon}
		        itemListDeliveryAddr={itemListDeliveryAddr}
		        handleViewMap={handleViewMap}
		        changePrimaryAddress={changePrimaryAddress}
		        isUpdatePrimaryAddressReqeust={isUpdatePrimaryAddressReqeust}
		        indexPrimaryAddr={indexPrimaryAddr}
		        modal={{}} // pass modal props if needed
		        handleToggle={handleToggle}
		        setListAddress={setListAddress}
		        dpBalance={dpBalance} setDpBalance={setDpBalance}
		        dpTierId={dpTierId} setDpTierId={setDpTierId}
		        dpSelectedTier={dpSelectedTier} setDpSelectedTier={setDpSelectedTier}
		        dpGraceTierId={dpGraceTierId} setDpGraceTierId={setDpGraceTierId}
		        dpGraceSelectedTier={dpGraceSelectedTier} setDpGraceSelectedTier={setDpGraceSelectedTier}
		        onViewDelipointTransactions={handleViewDelipointTransactions}
		        calculateDPTier={calculateDPTier}
		        onEvaluateCustomerTier={handleEvaluateCustomerTier}
	        />

	        {/* Delipoint Transactions Modal */}
	        <Dialog
		        open={isDelipointTransactionModalOpen}
		        onClose={handleCloseDelipointTransactionModal}
		        maxWidth="md"
		        fullWidth
	        >
		        <DialogTitle>
		        	Delipoint Transactions {delipointTransactionTotal > 0 && `(${delipointTransactions.length}/${delipointTransactionTotal})`}
		        </DialogTitle>
		        <DialogContent 
		        	dividers
		        	style={{maxHeight: '500px', overflowY: 'auto'}}
		        	onScroll={(event) => {
		        		const dialogContent = event.currentTarget;
		        		if (
		        			dialogContent.scrollHeight - dialogContent.scrollTop <=
		        			dialogContent.clientHeight + 50
		        		) {
		        			handleLoadMoreDelipointTransactions();
		        		}
		        	}}
		        >
		        	{isDelipointTransactionLoading ? (
		        		<Box display="flex" justifyContent="center" p={3}>
		        			<CircularProgress />
		        		</Box>
		        	) : (
		        		<>
		        			<TableContainer>
		        				<MTable>
		        					<TableHead>
		        						<TableRow>
		        							<TableCell>Date</TableCell>
		        							<TableCell>Type</TableCell>
		        							<TableCell>Points</TableCell>
		        							<TableCell>Expiration Date</TableCell>
		        							<TableCell>Description</TableCell>
		        						</TableRow>
		        					</TableHead>
		        					<TableBody>
		        						{delipointTransactions.length > 0 ? (
		        							delipointTransactions.map((transaction, index) => (
		        								<TableRow key={index}>
		        									<TableCell>{moment(transaction.createdAt).format('LLL')}</TableCell>
		        									<TableCell>{transaction.type}</TableCell>
		        									<TableCell>{transaction.points}</TableCell>
		        									<TableCell>{transaction.expiration_date ? moment(transaction.expiration_date).format('LLL') : '-'}</TableCell>
		        									<TableCell>{transaction.comment || 'N/A'}</TableCell>
		        								</TableRow>
		        							))
		        						) : (
		        							<TableRow>
		        								<TableCell colSpan={4} align="center">No transactions found</TableCell>
		        							</TableRow>
		        						)}
		        					</TableBody>
		        				</MTable>
		        			</TableContainer>
		        			{isDelipointTransactionLoadingMore && (
		        				<Box display="flex" justifyContent="center" p={2}>
		        					<CircularProgress size={30} />
		        				</Box>
		        			)}
		        		</>
		        	)}
		        </DialogContent>
		        <DialogActions>
		        	<Button onClick={handleCloseDelipointTransactionModal} color="primary">
		        		Close
		        	</Button>
		        </DialogActions>
	        </Dialog>

	        <ListCouponOwnerDialog
		        open={couponModal}
		        onClose={handleToggleCoupon}
		        couponList={couponList}
		        couponFetching={couponFetching}
		        onDelete={(coupon) => handleToggleModalRemoveUser(coupon)}
		        onGenerate={async () => {
			        await handleToggleGenerateCoupon()
			        setCouponModal(false);
			        setGenerateCouponModal(true);
		        }}
	        />

	        <GenerateCouponDialog
		        open={generateCouponModal}
		        onClose={handleToggleGenerateCoupon}
		        couponTemplateList={couponTemplateList}
		        couponFetching={couponFetching}
		        onSelect={(coupon) => setCouponSelected(coupon)}
		        selectedCoupon={couponSelected}
		        onCreate={handleGenerateCouponToCustomer}
		        isRequesting={isRequesting}
	        />

	        <Modal
            show={isShowMapModal}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            size="lg"
            onHide={handleCloseMap}
          >
            <Modal.Header closeButton>
              <Modal.Title>Update Address</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <PlacesAutocomplete
                    searchOptions={{componentRestrictions: { country: ['kh'] },
                        types: []}}
                    value={area}
                    onChange={(address) => {
                        setArea(address);
                    }}
                    onSelect={(address) => {
                        setArea(address);
                        geocodeByAddress(address)
                            .then(results => {
                                setCoordinate({latitude: results[0].geometry.location.lat(), longitude: results[0].geometry.location.lng()});
                                results[0].address_components.map( async function(item, idx){
                                    item.types.map(async function(item1, idx1){
                                        if (item1 == "administrative_area_level_1") {
                                            if (item.long_name == 'Phnom Penh') {
                                              setCity('Phnom Penh');
                                            } else {
                                              setCity("Province");
                                            }
                                        }
                                    })
                                })
                            })
                    }}
                >
                    {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                        <div>
                            <span className="searchBar">
                            {area === "" && <i className="fa fa-search" aria-hidden="true"></i>}
                                <TextField
                                    {...getInputProps({
                                        placeholder: '      Search Address *',
                                        label: '',
                                        className: 'taimage',
                                        id: 'searchlocation',
                                        as: 'textarea',
                                        error: error.search_pin,
                                    })}
                                />
                            </span>

                            <div className="autocomplete-dropdown-container">
                                {loading && <div>Loading...</div>}
                                {suggestions.map(suggestion => {
                                    const className = suggestion.active
                                        ? 'suggestion-item--active'
                                        : 'suggestion-item';
                                    // inline style for demonstration purpose
                                    const style = suggestion.active
                                        ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                        : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                    return (
                                        <div
                                            {...getSuggestionItemProps(suggestion, {
                                                className,
                                                style,
                                            })}
                                        >
                                            <span>{suggestion.description}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                </PlacesAutocomplete>
                {modalshow ? <>
                    <div title="My Location" onClick={() => {
                        getLocation();
                    }
                    } style={{
                        position: "absolute",
                        top: "25%",
                        left: mql.matches ? "5%" : "7%",
                        zIndex: "1000000",
                        border: "2px solid rgb(0,120,201)",
                        borderRadius: "50%",
                        padding: "10px",
                        backgroundColor: "white"
                    }}>
	                    <img src={require('../../../assets/icons/Loc.png')} style={{width: mql.matches ? "40px" : "29px"}}
                             alt={"my location"}/>
                    </div>
                </> : null
                }
                <Suspense fallback={<p>Loading...</p>}>
                  <GoogleMaps
                    isMarkerShown={true}
                    latitude={coordinate.latitude}
                    longitude={coordinate.longitude}
                    onMarkerDragEnd={onMarkerDragEnd}
                    onMyLocation={getLocation}
                    fetchAddress={fetchAddress}
                  />
                </Suspense>
            </Modal.Body>
            <Modal.Footer>
                <Button disabled={isUpdateAddressReqeust} variant="primary" onClick={handleUpdateAddress}>
                    {
                        isUpdateAddressReqeust?
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />:
                            null
                    }
                    <span className="pl-2 pr-2">Update</span>
                </Button>

              <Button
                variant="secondary"
                onClick={handleCloseMap}
              >
                Close
              </Button>
            </Modal.Footer>
        </Modal>

            <Toast className={toastBgColor}
                   onClose={() => setShowToast(false)}
                   show={showToast}
                   delay={3000}
                   autohide
                   style={{
                       position: 'fixed',
                       top: 70,
                       right: 35,
                       zIndex: 1041,
                       width: "300px"
                   }}
            >
                <Toast.Header>
                    <strong className="mr-auto m-3">{toastMessage}</strong>
                </Toast.Header>
            </Toast>

          {paginationBasic}
        </Col>
      </Row>
	    {/*  edit address*/}
	    <EditCustomerAddress
		    modal={modal}
		    handleToggle={handleToggle}
		    data={addressData}
		    userData={editCustom}
		    setItemListDeliveryAddr={setItemListDeliveryAddr}
		    setIsUpdateAddressRequest={setIsUpdateAddressRequest}
		    addressEdit={addressEdit}
		    setListAddress={setListAddress}
	    />

        {/*wallet*/}
        {isShowWalletTransactionModal &&
            <WalletTransactionDialog
                isShowWalletTransactionModal={isShowWalletTransactionModal}
                handleViewWalletTransaction={handleViewWalletTransaction}
                customerToViewWallet={customerToViewWallet}
                handleCloseWalletTransactionModal={handleCloseWalletTransactionModal}
                handleLoadMoreTransactions={handleLoadMoreTransactions}
                handleOpenUpdateTransaction={handleOpenUpdateWalletTransactionModal}
                nextOffset={nextOffset}
                walletInfo={walletInfo}
                setIsShowAddWalletTranModal={setIsShowAddWalletTranModal}
                isShowAddWalletTranModal={isShowAddWalletTranModal}
                walletTransactions={walletTransactions}
                isWalletRequesting={isWalletRequesting}
            />
        }
        {isShowAddWalletTranModal&&
            <AddWalletTransactionDialog
                open={isShowAddWalletTranModal}
                onClose={handleCloseAddWalletTransactionModal}
                onSubmit={handleSubmitAddWalletTransaction}
                transactionType={transactionType}
                setTransactionType={setTransactionType}
                amount={amount}
                setAmount={setAmount}
                reason={reason}
                setReason={setReason}
                comment={comment}
                setComment={setComment}
                errors={walletFormError}
                isSubmitting={isRequestingUpsert}
                recentOrders={orderOptions}
                recentOrderLoading={recentOrderLoading}
                orderNumber={orderNumber}
                setOrderNumber={setOrderNumber}
            />}
	    {isShowUpdateWalletTranModal &&
		    <UpdateWalletTransactionDialog
			    open={isShowUpdateWalletTranModal}
			    onClose={handleCloseUpdateWalletTransactionModal}
			    onSubmit={handleSubmitUpdateWalletTransaction}
			    orderNumber={orderNumber}
			    setOrderNumber={setOrderNumber}
			    recentOrders={orderOptions}
			    recentOrderLoading={recentOrderLoading}
			    isSubmitting={isRequestingUpsert}
			    selectedTransaction={selectedTransaction}
            />}
    </HelpPageWrapper>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(Customer);
